/* eslint-disable */
import {
  Button,
  Tooltip,
  message,
  Card,
  Input,
  ColorPicker,
  Divider,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

import http from "@/utils/http";
import api from "@/utils/api";
import "./component/index.css";
export default function System() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [appData, setAppData] = useState(null);
  const [pcData, setPcData] = useState(null);
  const [commonData, setCommonData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apploading, setAppLoading] = useState(false);
  const [comloading, setComLoading] = useState(false);
  const [showCommonButton, setShowCommonButton] = useState(false);
  const [showPcButton, setShowPcButton] = useState(false);
  const [showAppButton, setShowAppButton] = useState(false);
  const [cardLoading, setCardLoading] = useState({
    common: true,
    pc: true,
    app: true,
  });
  // 初始化时获取数据
  useEffect(() => {
    fetchData();
  }, []);

  // 请求数据
  const fetchData = async () => {
    try {
      setCardLoading({
        common: true,
        pc: true,
        app: true,
      });
      const response = await http.get(`${api.getSystemSettings}`);
      setData(response.data);
      const appArr = response.data?.["2"] || {};
      setAppData(appArr);
      const PCArr = response.data?.["1"] || {};
      setPcData(PCArr);
      const commonArr = response.data?.["3"] || {};
      setCommonData(commonArr);
      setCardLoading({
        common: false,
        pc: false,
        app: false,
      });
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    }
  };

  // 从 appData 中提取颜色设置  --APP
  const getColorSettings = () => {
    if (!appData?.maintenance_image_upload_watermark?.setting) {
      return { r: 0, g: 0, b: 0, opacity: 1 };
    }

    try {
      const setting = JSON.parse(
        appData.maintenance_image_upload_watermark.setting
      );
      return {
        r: setting.r || 0,
        g: setting.g || 0,
        b: setting.b || 0,
        opacity: setting.opacity || 1,
      };
    } catch (e) {
      return { r: 0, g: 0, b: 0, opacity: 1 };
    }
  };
  const getAlbumColorSettings = () => {
    if (!appData?.maintenance_image_album_watermark?.setting) {
      return { r: 0, g: 0, b: 0, opacity: 1 };
    }

    try {
      const setting = JSON.parse(
        appData.maintenance_image_album_watermark.setting
      );
      return {
        r: setting.r || 0,
        g: setting.g || 0,
        b: setting.b || 0,
        opacity: setting.opacity || 1,
      };
    } catch (e) {
      return { r: 0, g: 0, b: 0, opacity: 1 };
    }
  };

  const colorSettings = getColorSettings();
  const colorValue = `rgba(${colorSettings.r}, ${colorSettings.g}, ${colorSettings.b}, ${colorSettings.opacity})`;

  const colorAlbumSettings = getAlbumColorSettings();
  const colorAlbumValue = `rgba(${colorAlbumSettings.r}, ${colorAlbumSettings.g}, ${colorAlbumSettings.b}, ${colorAlbumSettings.opacity})`;

  const handleColorChange = (color) => {
    setShowAppButton(true);
    const { r, g, b, a } = color.toRgb();
    setAppData((prev) => ({
      ...prev,
      maintenance_image_upload_watermark: {
        ...prev?.maintenance_image_upload_watermark,
        setting: JSON.stringify({
          ...(prev?.maintenance_image_upload_watermark?.setting
            ? JSON.parse(prev.maintenance_image_upload_watermark.setting)
            : {}),
          r,
          g,
          b,
          opacity: a,
        }),
      },
    }));
  };

  const handleAlbumColorChange = (color) => {
    setShowAppButton(true);
    const { r, g, b, a } = color.toRgb();
    setAppData((prev) => ({
      ...prev,
      maintenance_image_album_watermark: {
        ...prev?.maintenance_image_album_watermark,
        setting: JSON.stringify({
          ...(prev?.maintenance_image_album_watermark?.setting
            ? JSON.parse(prev.maintenance_image_album_watermark.setting)
            : {}),
          r,
          g,
          b,
          opacity: a,
        }),
      },
    }));
  };

  const handleSizeChange = (e) => {
    const newSize = e.target.value;
    setShowAppButton(true);
    setAppData((prev) => ({
      ...prev,
      maintenance_image_upload_size: {
        ...prev?.maintenance_image_upload_size,
        setting: newSize,
      },
    }));
  };

  const handleShowDayChange = (e) => {
    const newSize = e.target.value;
    setShowAppButton(true);
    setAppData((prev) => ({
      ...prev,
      maintenance_finish_show_days: {
        ...prev?.maintenance_finish_show_days,
        setting: newSize,
      },
    }));
  };
  const handleJobChange = (e) => {
    const newSize = e.target.value;
    setShowAppButton(true);
    setAppData((prev) => ({
      ...prev,
      maintenance_invoice_job_effective_distance: {
        ...prev?.maintenance_invoice_job_effective_distance,
        setting: newSize,
      },
    }));
  };

  const handleRegisterChange = (e) => {
    const newSize = e.target.value;
    setShowAppButton(true);
    setAppData((prev) => ({
      ...prev,
      tenant_register_max_number: {
        ...prev?.tenant_register_max_number,
        setting: newSize,
      },
    }));
  };

  const handleMaintenanceChange = (e) => {
    const newSize = e.target.value;
    setShowAppButton(true);
    setAppData((prev) => ({
      ...prev,
      tenant_maintenance_max_number: {
        ...prev?.tenant_maintenance_max_number,
        setting: newSize,
      },
    }));
  };
  // pc input
  const handlePCChange = (e) => {
    const newSize = e.target.value;
    setShowPcButton(true);
    setPcData((prev) => ({
      ...prev,
      login_valid_time: {
        ...prev?.login_valid_time,
        setting: newSize,
      },
    }));
  };

  const handlePCDayChange = (e) => {
    const newSize = e.target.value;
    setShowPcButton(true);
    setPcData((prev) => ({
      ...prev,
      device_id_effective_days: {
        ...prev?.device_id_effective_days,
        setting: newSize,
      },
    }));
  };
  //  打卡时间
  const handleWorkExtensionChange = (e) => {
  const newSize = e.target.value;
  setShowPcButton(true);
  setPcData((prev) => ({
    ...prev,
    work_extension_duration: {
      ...prev?.work_extension_duration,
      setting: newSize,
    },
  }));
};
  const handleComTimeChange = (e) => {
    const newSize = e.target.value;
    setShowCommonButton(true);
    setCommonData((prev) => ({
      ...prev,
      login_lock_time: {
        ...prev?.login_lock_time,
        setting: newSize,
      },
    }));
  };

  const handleJobCapChange = (e) => {
    const newSize = e.target.value;
    setShowCommonButton(true);
    setCommonData((prev) => ({
      ...prev,
      maintenance_vendor_job_cap: {
        ...prev?.maintenance_vendor_job_cap,
        setting: newSize,
      },
    }));
  };
  const handleJobAgedChange = (e) => {
    const newSize = e.target.value;
    setShowCommonButton(true);
    setCommonData((prev) => ({
      ...prev,
      maintenance_vendor_aged_allow: {
        ...prev?.maintenance_vendor_aged_allow,
        setting: newSize,
      },
    }));
  };
  const handleComattemptsChange = (e) => {
    const newSize = e.target.value;
    setShowCommonButton(true);
    setCommonData((prev) => ({
      ...prev,
      login_max_attempts: {
        ...prev?.login_max_attempts,
        setting: newSize,
      },
    }));
  };

  // 提交
  const handlePcSubmit = async () => {
    setLoading(true);
    try {
      const params = [
        {
          id: pcData.login_valid_time.id,
          setting: pcData.login_valid_time.setting,
        },
        {
          id: pcData.device_id_effective_days.id,
          setting: pcData.device_id_effective_days.setting,
        },
         {
        id: pcData.work_extension_duration.id,
        setting: pcData.work_extension_duration.setting,
      },
      ];
      const response = await http.post(`${api.getSettingsupdate}`, params);
      if (response.code === "1") {
        message.success("Modification is successful.");
        fetchData();
        setLoading(false);
        setShowPcButton(false);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
    }
  };

  // APP 提交
  const handleAppSubmit = async () => {
    setAppLoading(true);
    try {
      const params = [
        {
          id: appData.maintenance_image_upload_size.id,
          setting: appData.maintenance_image_upload_size.setting,
        },
        {
          id: appData.maintenance_image_album_watermark.id,
          setting: appData.maintenance_image_album_watermark.setting,
        },
        {
          id: appData.maintenance_image_upload_watermark.id,
          setting: appData.maintenance_image_upload_watermark.setting,
        },
        {
          id: appData.maintenance_finish_show_days.id,
          setting: appData.maintenance_finish_show_days.setting,
        },
        {
          id: appData.maintenance_invoice_job_effective_distance.id,
          setting: appData.maintenance_invoice_job_effective_distance.setting,
        },
        {
          id: appData.tenant_register_max_number.id,
          setting: appData.tenant_register_max_number.setting,
        },
        {
          id: appData.tenant_maintenance_max_number.id,
          setting: appData.tenant_maintenance_max_number.setting,
        },
      ];
      const response = await http.post(`${api.getSettingsupdate}`, params);
      if (response.code === "1") {
        message.success("Modification is successful.");
        fetchData();
        setAppLoading(false);
        setShowAppButton(false);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
    }
  };

  // common 提交
  const handleComSubmit = async () => {
    setComLoading(true);
    try {
      const params = [
        {
          id: commonData.login_lock_time.id,
          setting: commonData.login_lock_time.setting,
        },
        {
          id: commonData.login_max_attempts.id,
          setting: commonData.login_max_attempts.setting,
        },
        {
          id: commonData.maintenance_vendor_job_cap.id,
          setting: commonData.maintenance_vendor_job_cap.setting,
        },
        {
          id: commonData.maintenance_vendor_aged_allow.id,
          setting: commonData.maintenance_vendor_aged_allow.setting,
        },
      ];
      const response = await http.post(`${api.getSettingsupdate}`, params);
      if (response.code === "1") {
        message.success("Modification is successful.");
        fetchData();
        setComLoading(false);
        setShowCommonButton(false);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
    }
  };
  return (
      <div className="Main">
        <Card title="Common" className="card_box" loading={cardLoading.common}>
          <div className="appcontent">
            <div className="content_list">
              <div className="content_des">
                {commonData?.login_max_attempts?.name || ""}
                <Tooltip title={commonData?.login_max_attempts?.description}>
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={commonData?.login_max_attempts?.setting || ""}
                  onChange={handleComattemptsChange}
                  suffix="Times"
                />
              </div>
            </div>
            <div className="content_list">
              <div className="content_des">
                {commonData?.login_lock_time?.name || ""}
                <Tooltip title={commonData?.login_lock_time?.description}>
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={commonData?.login_lock_time?.setting || ""}
                  onChange={handleComTimeChange}
                  suffix="Minute"
                />
              </div>
            </div>
            <div className="content_list">
              <div className="content_des">
                {commonData?.maintenance_vendor_job_cap?.name || ""}
                <Tooltip
                  title={commonData?.maintenance_vendor_job_cap?.description}
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={commonData?.maintenance_vendor_job_cap?.setting || ""}
                  onChange={handleJobCapChange}
                  suffix="Count"
                />
              </div>
            </div>
            <div className="content_list">
              <div className="content_des">
                {commonData?.maintenance_vendor_aged_allow?.name || ""}
                <Tooltip
                  title={commonData?.maintenance_vendor_aged_allow?.description}
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={
                    commonData?.maintenance_vendor_aged_allow?.setting || ""
                  }
                  onChange={handleJobAgedChange}
                  suffix="Days"
                />
              </div>
            </div>

            <Divider />
            <div className="content_btn">
              {showCommonButton && (
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={handleComSubmit}
                  loading={comloading}
                >
                  Click to update
                </Button>
              )}
            </div>
          </div>
        </Card>

        <Card title="PC" className="card_box" loading={cardLoading.pc}>
          <div className="appcontent">
            <div className="content_list">
              <div className="content_des">
                {pcData?.login_valid_time?.name || ""}
                <Tooltip title={pcData?.login_valid_time?.description}>
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={pcData?.login_valid_time?.setting || ""}
                  onChange={handlePCChange}
                  suffix="Hour"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {pcData?.device_id_effective_days?.name || ""}
                <Tooltip title={pcData?.device_id_effective_days?.description}>
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={pcData?.device_id_effective_days?.setting || ""}
                  onChange={handlePCDayChange}
                  suffix="Days"
                />
              </div>
            </div>

    <div className="content_list">
      <div className="content_des">
        {pcData?.work_extension_duration?.name || ""}
        <Tooltip title={pcData?.work_extension_duration?.description}>
          <InfoCircleOutlined style={{ fontSize: "20px", marginLeft: "10px" }} />
        </Tooltip>
      </div>
      <div className="content_size">
        <Input
          value={pcData?.work_extension_duration?.setting || ""}
          onChange={handleWorkExtensionChange}
          suffix="Days"
        />
      </div>
      </div>
            <Divider />
            <div className="content_btn">
              {showPcButton && (
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={handlePcSubmit}
                  loading={loading}
                >
                  Click to update
                </Button>
              )}
            </div>
          </div>
        </Card>

        <Card title="APP" className="card_box" loading={cardLoading.app}>
          <div className="appcontent">
            <div className="content_list">
              <div className="content_des">
                {appData?.maintenance_image_upload_watermark?.name || ""}
                <Tooltip
                  title={
                    appData?.maintenance_image_upload_watermark?.description
                  }
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <ColorPicker
                  value={colorValue}
                  onChange={handleColorChange}
                  showText
                  format="rgb"
                  className="color"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {appData?.maintenance_image_album_watermark?.name || ""}
                <Tooltip
                  title={
                    appData?.maintenance_image_album_watermark?.description
                  }
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <ColorPicker
                  value={colorAlbumValue}
                  onChange={handleAlbumColorChange}
                  showText
                  format="rgb"
                  className="color"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {appData?.maintenance_image_upload_size?.name || ""}
                <Tooltip
                  title={appData?.maintenance_image_upload_size?.description}
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={appData?.maintenance_image_upload_size?.setting || ""}
                  onChange={handleSizeChange}
                  suffix="KB"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {appData?.maintenance_finish_show_days?.name || ""}
                <Tooltip
                  title={appData?.maintenance_finish_show_days?.description}
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={appData?.maintenance_finish_show_days?.setting || ""}
                  onChange={handleShowDayChange}
                  suffix="Days"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {appData?.maintenance_invoice_job_effective_distance?.name ||
                  ""}
                <Tooltip
                  title={
                    appData?.maintenance_invoice_job_effective_distance
                      ?.description
                  }
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={
                    appData?.maintenance_invoice_job_effective_distance
                      ?.setting || ""
                  }
                  onChange={handleJobChange}
                  suffix="Feet"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {appData?.tenant_register_max_number?.name || ""}
                <Tooltip
                  title={appData?.tenant_register_max_number?.description}
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={appData?.tenant_register_max_number?.setting || ""}
                  onChange={handleRegisterChange}
                  suffix="Count"
                />
              </div>
            </div>

            <div className="content_list">
              <div className="content_des">
                {appData?.tenant_maintenance_max_number?.name || ""}
                <Tooltip
                  title={appData?.tenant_maintenance_max_number?.description}
                >
                  <InfoCircleOutlined
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                  />
                </Tooltip>
              </div>
              <div className="content_size">
                <Input
                  value={appData?.tenant_maintenance_max_number?.setting || ""}
                  onChange={handleMaintenanceChange}
                  suffix="Count"
                />
              </div>
            </div>

            <Divider />
            <div className="content_btn">
              {showAppButton && (
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={handleAppSubmit}
                  loading={apploading}
                >
                  Click to update
                </Button>
              )}
            </div>
          </div>
        </Card>
      </div>
   
  );
}
